import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserAccount, DefaultUserAccount } from '../user-account';
import { PersonInterface, DefaultPersonTable } from '../person-interface';
import { SubClan, subClans } from '../models/clan-interfaces';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  private activeUserAccount_ = new BehaviorSubject<UserAccount>(new DefaultUserAccount());
  private activeUri_ = new BehaviorSubject<string>('createPerson');
  private targetPerson_ = new BehaviorSubject<PersonInterface>(new DefaultPersonTable());
  private targetCaption_ = new BehaviorSubject<string>('start family');
  private lastSelectedClan_ = new BehaviorSubject<SubClan>(subClans[0]);
  private friend_Account_id_ = new BehaviorSubject<string>('');
  // Observables to allow other components to subscribe to changes
  activeUserAccount$ = this.activeUserAccount_.asObservable();
  activeUri$ = this.activeUri_.asObservable();
  targetPerson$ = this.targetPerson_.asObservable();
  targetCaption$ = this.targetCaption_.asObservable();
  lastSelectedRow$ = this.lastSelectedClan_.asObservable();
  friend_Account_id$ = this.friend_Account_id_.asObservable();


  constructor() {
  }

  // Method to update activeUserAccount
  setActiveUserAccount(userAccount: UserAccount) {
    this.activeUserAccount_.next(userAccount);
  }

  // Method to update activeUri
  setActiveUri(uri: string) {
    this.activeUri_.next(uri);
  }

  // Method to update targetPerson
  setTargetPerson(person: PersonInterface) {
    this.targetPerson_.next(person);
  }

  // Method to update targetCaption
  setTargetCaption(caption: string) {
    this.targetCaption_.next(caption);
  }

  // Method to update lastSelectedRow
  setLastSelectedClan(row: SubClan) {
    this.lastSelectedClan_.next(row);
  }

  // Method to update friend_Account_id
  setFriend_Account_id(friend_Account_id: string) {
    this.friend_Account_id_.next(friend_Account_id);
  }
    // Method to retrieve the current activeUserAccount value as an Observable
    getActiveUserAccount(): Observable<UserAccount> {
      // Emit only when the user account has been set (id is not empty)
      return this.activeUserAccount_.asObservable().pipe(
        filter(userAccount => !!userAccount.id), // Ensure that the userAccount has a valid ID
        take(1) // Complete after the first emission (optional)
      );
    }

  // Method to retrieve the current activeUri value
  getActiveUri(): string {
    return this.activeUri_.getValue();
  }

  // Method to retrieve the current targetPerson value
  getTargetPerson(): PersonInterface {
    return this.targetPerson_.getValue();
  }

  // Method to retrieve the current targetCaption value
  getTargetCaption(): string {
    return this.targetCaption_.getValue();
  }

  // Method to retrieve the current lastSelectedRow value
  getLastSelectedClan(): SubClan {
    return this.lastSelectedClan_.getValue();
  }

  // Method to retrieve the current friend_Account_id value
  getFriend_Account_id(): string {
    return this.friend_Account_id_.getValue();
  }
}
